
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VXETable from "vxe-table";

import { addOtherFee ,removeOtherFee} from "@/api/supplier-payment";


@Component({
  name: "CreateFee"
})
export default class extends Vue {
  @Prop({ default: "" }) private id: "";
  @Prop({ default: false }) private showButton: boolean;
  @Prop({ default: "" }) private state: "";

  private form = {
    "deduction": null,
    "type": null,
    "amount": null,
    "remark": null
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "费用类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "补扣款",
      prop: "deduction",
      key: "deduction",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "amount",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;

  public tableCol1 = [
    {
      label: "费用类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "补扣款",
      prop: "deduction",
      key: "deduction",
      type: "boolean_status",
      trueTxt: "扣款",
      falseTxt: "补款",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "amount",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    }
  ] as any;

  private list = [
    {
      label: "补扣款",
      prop: "deduction",
      key: "deduction",
      type: "select",
      placeholder: "请选择补扣款",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择补扣款",
        trigger: "blur"
      },
      options: [
        {
          name: "补款",
          value: false
        },
        {
          name: "扣款",
          value: true
        },
      ]
    },
    {
      label: "金额",
      prop: "amount",
      key: "inquiryReferenceNumber",
      type: "inputNumber",
      placeholder: "请填写金额",
      clearable: true,
      maxlength: 100,
      precision: 2,
      rules: {
        required: true,
        message: "请填写金额",
        trigger: "blur"
      }
    },
    {
      label: "费用类型",
      prop: "type",
      key: "type",
      type: "input",
      placeholder: "请填写费用类型",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请填写费用类型",
        trigger: "blur"
      }
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请填写备注",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请填写备注",
        trigger: "blur"
      }
    }

  ];

  private show = false;

  private close() {
    this.show = false;
    this.$emit("update:show", false);
  }

  private open() {
    this.show = true;
  }

  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            await this.addOtherFee();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  //  删除
  public async handleDelete(scope) {
    await removeOtherFee(scope.row.id);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
    this.table.list.splice(scope.$index, 1);
  }

  private handleAdd() {
    this.open();
  }

  // 新建
  private async addOtherFee() {
    const { amount, remark, type,deduction } = this.form;
    let params = {
      amount,
      remark,
      deduction,
      type
    };
    try {
      await addOtherFee(this.id, params);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }
}
